module.exports = "//static.hsappstatic.net/conversations-embed/static-1.28383/sass/messagesWidgetShell.sass"